module.exports = __webpack_public_path__ + "img/Corporativo.4ce65130.png";